import React, { useEffect } from 'react';

import { useContextStore } from '../../../../stores/storeRoot';

const CookiebotScript: React.FC = () => {
  const { selectedUserLanguage } = useContextStore();

  useEffect(() => {
    console.log('CookiebotScript', selectedUserLanguage);
    const scriptId = 'CookiebotBanner';
    const lang =
      selectedUserLanguage.slice(0, 2) ??
      (process.env.COOKIEBOT_FALLBACK_LANGUAGE || 'en');

    let scriptElement = document.getElementById(scriptId) as HTMLScriptElement;
    const cookieBannerScriptAlreadyExists = scriptElement ? true : false;

    if (cookieBannerScriptAlreadyExists) {
      scriptElement.setAttribute('data-culture', lang);

      // only renew when cookiebot banner is "displayed" right now
      if (window.Cookiebot?.dialog?.visible) {
        window.Cookiebot?.renew();
      }
    } else {
      scriptElement = document.createElement('script');
      scriptElement.id = scriptId;
      scriptElement.src = 'https://consent.cookiebot.com/uc.js';
      scriptElement.setAttribute('data-culture', lang);
      scriptElement.setAttribute('data-widget-enabled', 'false');
      scriptElement.setAttribute('async', '');
      scriptElement.setAttribute(
        'data-cbid',
        process.env.COOKIEBOT_ID || 'not set'
      );
      scriptElement.type = 'text/javascript';
      document.body.appendChild(scriptElement);
    }
  }, [selectedUserLanguage]);

  return null;
};

export default CookiebotScript;
